import { Grid, FormControl, Button } from '@mui/material';
import { IComponentCss } from '@tap/mui-ui';
import { CommentEditor } from './CommentEditor';
import { UseCommentState } from './useComment';

/*
*   Добавить комментарий
*/

type IAddCommentFormProps = {
    commentState: UseCommentState,
    addNewCommentCallback: () => void,
    handleHideNewCommentForm: () => void,
}


const css: IComponentCss = {
    addComment: {
        border: '0px solid #E0E0E0',
        borderRadius: '4px',
        marginTop: '6px',
        width: '100%',
        zIndex: 1,
    },
    buttonsWrap: {
        marginTop: '12px',
    },
    button: {
        textTransform: 'none',
    },
    buttonSend: {
        marginRight: '10px',
    },
}

export function AddCommentForm({
    commentState,
    addNewCommentCallback,
    handleHideNewCommentForm,
}: IAddCommentFormProps) {

    const handleAddComment = () => {
        commentState.addComment().then(() => {
            addNewCommentCallback && addNewCommentCallback();
            handleHideNewCommentForm && handleHideNewCommentForm();
        });
    }

    const handleCancel = () => {
        commentState.clearComment();
        handleHideNewCommentForm && handleHideNewCommentForm();
    }

    return (
        <Grid container sx={css.addComment}>
            <FormControl fullWidth>
                <CommentEditor {...commentState} />
            </FormControl>
            <Grid
                container
                justifyContent='flex-end'
                sx={css.buttonsWrap}
            >
                <Button
                    variant='contained'
                    disableElevation
                    sx={{ ...css.button, ...css.buttonSend }}
                    onClick={() => handleAddComment()}
                    disabled={!commentState.message.length || !commentState.message.trim()}
                >
                    Добавить
                </Button>
                <Button
                    variant='text'
                    sx={css.button}
                    onClick={handleCancel}
                >
                    Отмена
                </Button>
            </Grid>
        </Grid >
    );
}
